import { ContactSchema } from "store/schemas/ContactSchema";
import * as Yup from "yup";

export const UserProfileSchema = ContactSchema.shape({
  company: Yup.string(),
  pictures: Yup.mixed(),
});
